import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <motion.div 
      className="not-found-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="not-found-content">
        <motion.div 
          className="illustration"
          animate={{ y: [-10, 10, -10] }}
          transition={{ duration: 4, repeat: Infinity }}
        >
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            {/* Custom 404 illustration */}
            <circle cx="100" cy="100" r="90" fill="#f0f0f0" />
            <text x="50%" y="50%" textAnchor="middle" fill="#BE2025" fontSize="60" dy=".3em">404</text>
          </svg>
        </motion.div>
        <h1>Oops! Page not found</h1>
        <p>We can't seem to find the page you're looking for.</p>
        <div className="actions">
          <button onClick={() => navigate(-1)} className="back-button">
            Go Back
          </button>
          <button onClick={() => navigate('/')} className="home-button">
            Homepage
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default NotFound;